import * as ko from 'knockout';
import * as ajax from '../app-lib/ajax_proxy';
//图片上传
ko.bindingHandlers["pscUpload"] = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var fileinput = element;
        var value = ko.utils.unwrapObservable(valueAccessor());
        console.info("--init upload  value---  " + value);
        fileinput.addEventListener("change", function (e) {
            var input = e.currentTarget;
            var fd = new FormData();
            if (input.files[0].type.split('/')[0] != 'image') {
                return window.popBox.show('上传的文件须是图片');
            }
            for (var i = 0; i < input.files.length; i++)
                // fd.set("", input.files.item(i))
                fd.append("file", input.files.item(i)); //后台使用参数名file数组来获取所有上传文件
            value = ko.utils.unwrapObservable(valueAccessor());
            console.info("--change upload  value---  " + value);
            //fd.append("upData", value);//获取页面绑定值作为提交表单时同时提交的参数值，后台通过upData名字获取上传文件附带的其他信息
            fd.append("uid", window.localStorage.getItem('UserId'));
            fd.append("pid", value);
            ajax.post("/api/ice/pcuploadpic", fd).then(//注意后台提交API接口的一致
            function (ds) {
                // valueAccessor()(ds.length ? ds[0] : ds)
                if (allBindingsAccessor()["onUploaded"]) //如果该元素还绑定了onUploaded，可以调用该方法进行对返回值的处理
                 {
                    allBindingsAccessor()["onUploaded"](ds);
                }
            }).catch(function (e) {
                if (allBindingsAccessor()["onException"]) //如果该元素还绑定了onUploadException，可以调用该方法进行对返回值的处理
                 {
                    allBindingsAccessor()["onException"](e);
                }
            });
        });
    }
};
